import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import GridItem from './GridItem';

const UserInput = ({label,setInput,input,children,isPass,isRequired,isDate})=>{

return(
	<GridItem>
		<TextField
			label={isDate ? null : label}
			onChange={(e)=>{setInput(e?.target?.value)}}
			type={isPass ?'password' : isDate ? "date" : 'text' }
			placeholder={`${label}...`}
			required={isRequired ? isRequired : false}
			sx={{width:{xs:350,md:300}}}
			value={input}
			InputProps={{
				endAdornment: !isDate ?  (
					<InputAdornment  style={{justifyContent:"center",padding:5}} position="end">
						{children}
					</InputAdornment>
					)
				: null
			}}
		/>		
	</GridItem>


)
}

export default UserInput